import { CONSOLE_1_KAS_DEPLOYMENT_URL } from "./kas/utils";

export const buildInviteUrl = (orgId: string, inviteToken: string) =>
  `${CONSOLE_1_KAS_DEPLOYMENT_URL}/invite?token=${inviteToken}&orgID=${orgId}`;

export const isElectronApp = () => {
  // Renderer process
  if (
    typeof window !== "undefined" &&
    typeof window.process === "object" &&
    window.process.type === "renderer"
  ) {
    return true;
  }

  // Main process
  if (
    typeof process !== "undefined" &&
    typeof process.versions === "object" &&
    !!process.versions.electron
  ) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to false
  if (
    typeof navigator === "object" &&
    typeof navigator.userAgent === "string" &&
    navigator.userAgent.indexOf("Electron") >= 0
  ) {
    return true;
  }

  return false;
};

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
